import type { TimeProps } from './Time.types';

export const timeDefaults: Partial<TimeProps> = {
  size: 'none',
  context: 'none',
  fontWeight: 'normal',
};
